<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Position"
      text="Edit Position"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localPosition.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="localPosition.job_grade_id"
                v-validate="'required'"
                :items="jobGrades"
                label="Job Grade Code"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('job_grade_id')"
                data-vv-name="job_grade_id"
                data-vv-as="job grade code"
              />
            </v-col>

            <v-col cols="12">
              <span> Require provide justification if late in/early out? </span>
              <v-radio-group
                v-model="localPosition.require_justification_for_late_in_or_early_out"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <span> Employees assigned to this position are entitled with claim and claim through this system? </span>
              <v-radio-group
                v-model="localPosition.has_claim"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            
            <v-col 
              :cols="localPosition.is_active ? 12 : 6"
            >
              <span> Is Active? </span>
              <v-radio-group
                v-model="localPosition.is_active"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            
            <v-col 
              v-if="!localPosition.is_active"
              cols="6"
            >
              <v-menu
                v-model="inactiveDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="localPosition.inactive_date"
                    v-validate="!localPosition.is_active ? 'required' : ''"
                    label="Inactive Date"
                    :error-messages="errors.collect('inactiveDate')"
                    data-vv-name="inactiveDate"  
                    data-vv-as="inactive date"    
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localPosition.inactive_date"
                  no-title
                  @input="inactiveDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="px-10 white--text"       
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      position: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localPosition: null,
        jobGrades: [],
        inactiveDate: null,
        inactiveDateMenu: false,
      }
    },

    watch: {
      dialog: function (value) {
        if (value) {
          this.loadJobGrades()
          this.localPosition = { ...this.position }
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.positions().update(this.position.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localPosition.name,
          job_grade_id: this.localPosition.job_grade_id,
          require_justification_for_late_in_or_early_out: this.localPosition.require_justification_for_late_in_or_early_out,
          has_claim: this.localPosition.has_claim,
          is_active: this.localPosition.is_active,
          inactive_date: !this.localPosition.is_active ? this.localPosition.inactive_date : null,
        }
      },
      loadJobGrades () {
        this.$api.jobGrades().list()
          .then(res => {
            this.jobGrades = res.data
          })
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
